import { HttpStatusCode, PejHttpError } from '@common-lib';

import { baseClient } from '../common';
import { PortalConfigurationModel } from './portal-configuration.model';
import { PortalPublicConfigurationModel } from './portal-public-configuration.model';

const apiUrl = `/api/configuration`;

export const configurationClient = {
  getPublic: async (): Promise<PortalPublicConfigurationModel> => {
    const maxRetries = 30;
    const maxRetryDelay = 7000;
    let retryDelay = 1000;
    let retries = 0;

    while (retries <= maxRetries) {
      try {
        return await baseClient.get<PortalPublicConfigurationModel>(
          `${apiUrl}/public`,
        );
      } catch (error) {
        if (error instanceof PejHttpError) {
          if (
            error.statusCode === HttpStatusCode.NOT_FOUND ||
            error.statusCode === HttpStatusCode.LOCKED ||
            error.statusCode === HttpStatusCode.INTERNAL_SERVER_ERROR
          ) {
            throw error;
          } else if (
            error.statusCode === HttpStatusCode.SERVICE_UNAVAILABLE ||
            error.statusCode === HttpStatusCode.GATEWAY_TIMEOUT ||
            error.statusCode === HttpStatusCode.BAD_GATEWAY
          ) {
            // baseClient already retries on these errors. If we end up here it means
            // those retries already failed.
            throw error;
          }
        }

        await new Promise((resolve) => setTimeout(resolve, retryDelay));
        retryDelay = Math.min(retryDelay * 1.2, maxRetryDelay);
        retries++;
      }
    }

    throw new Error('Failed to fetch portal configuration');
  },

  get: async (): Promise<PortalConfigurationModel> => {
    return await baseClient.get<PortalConfigurationModel>(`${apiUrl}`);
  },
};
